(function (M) {
  if (!M) return;
  var d = document, hero = d.querySelector('.cp-hero');
  if (!hero) return;
  M.add(hero, '<div class="cp-streak mo-deco" aria-hidden="true"><i></i></div>', 'afterbegin');
  M.particles(hero, M.narrow ? 8 : 16);
  M.tag('.cp-hero .in > img', 'zoom');
  M.tag('.cp-hero h1', 'up', { d: 0.2 });
  M.tag('.cp-video h2', 'up');
  M.tag('.cp-vbox', 'zoom', { d: 0.15 });
  var bottle = d.querySelector('.cp-lead .bottle');
  if (bottle) { M.tag(bottle, 'rise'); bottle.classList.add('mo-float'); }
  M.tag('.cp-lead h2', 'up');
  M.tag('.cp-lead .txt p', 'up', { step: 0.12 });
  var ing = d.querySelector('.cp-ing');
  if (ing) {
    var cols = M.all(':scope > div:not(.plus)', ing);
    if (cols[0]) M.tag(cols[0], 'left');
    if (cols[1]) M.tag(cols[1], 'right');
    var plus = ing.querySelector('.plus');
    if (plus) { plus.classList.add('cp-pop'); M.tag(plus, 'zoom', { d: 0.45 }); }
  }
  M.tag('.cp-ben h2', 'up');
  M.tag('.cp-icons > div', 'up', { d: 0.1, step: 0.08 });
  M.tag('.cp-note', 'fade');
  M.tag('.cp-buy h2', 'up');
  M.tag('.cp-buy img', 'rise', { d: 0.1 });
  var btn = d.querySelector('.cp-buy .btn-order');
  if (btn) { btn.classList.add('cp-glint'); M.tag(btn, 'up', { d: 0.25 }); }
  M.tag('.b50-img img', 'zoom');
  var badge = d.querySelector('.b50-badge b');
  if (badge) {
    badge.classList.add('mo-ringed');
    badge.setAttribute('data-mo-play', '');
    badge.insertAdjacentHTML('afterbegin', '<svg class="mo-ring mo-deco" viewBox="0 0 62 62" aria-hidden="true"><circle cx="31" cy="31" r="29.5" pathLength="1"/></svg>');
    M.count(badge, '50');
  }
  var since = d.querySelector('.b50-since em');
  if (since) since.setAttribute('data-mo-drift', '70');
  M.tag('.b50-since', 'fade');
  M.tag('.b50-txt h2, .b50-txt p, .b50-txt .b50-cert', 'up', { step: 0.12 });
})(window.FJKMotion);
